import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n/i18n.js'
import VueMeta from 'vue-meta'
// import 'bootstrap'
// import 'bootstrap/dist/css/bootstrap.min.css'
// import 'bootstrap/dist/css/bootstrap.rtl.min.css'
import './assets/styles/custom-bootstrap.scss'

Vue.config.productionTip = false
Vue.use(VueMeta)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
